import React, { Component } from "react";
import { parseString } from "xml2js";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import api from "../../api";
import getPersonName from "../common/Name";
import getPhone from "../common/Phone";

class RelativesReportSection extends Component {
  state = {
    rows: [],
    activeIndex: 0,
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadSection = (node, props) => {
    const persons = _.get(node, "personReport.relatives[0].person");
    const rows = [];
    if (persons !== undefined && persons.length > 0) {
      _.forEach(persons, (person, index) => {
        rows.push(
          <Table.Row key={`rep_rel_row_${index}`}>
            <Table.Cell>
              <span className="text-bold">Name:</span>
            </Table.Cell>
            <Table.Cell>
              {getPersonName(
                _.get(person, "firstName[0]._", ""),
                _.get(person, "middleName[0]._", ""),
                _.get(person, "lastName[0]._", ""),
                this.props
              )}
            </Table.Cell>
            <Table.Cell>
              <span className="text-bold">Age:</span>
            </Table.Cell>
            <Table.Cell>{_.get(person, "age[0]._")}</Table.Cell>
            <Table.Cell>
              <span className="text-bold">Phone:</span>
            </Table.Cell>
            <Table.Cell>
              {getPhone(_.get(person, "phone[0]._"), this.props)}
            </Table.Cell>
          </Table.Row>
        );
      });
    }
    const recCount = rows.length;
    if (rows.length === 0) {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={100}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    props.updateItemCountBySection(props.sectionName, recCount);

    this.setState({
      rows,
    });
  };

  loadData = (props) => {
    const sectionNode = _.get(props.reportData, "personReport.relatives[0]");
    if (sectionNode) {
      this.loadSection(props.reportData, props);
    } else {
      const additionalData = _.cloneDeep(props.additionalData);
      additionalData.requestedSection = "relatives";
      api.report
        .person(additionalData)
        .then((res) => {
          parseString(res.data, { async: false }, (err, rslt) => {
            this.loadSection(rslt, props);
          });
        })
        .catch((err) => console.log("neighbors res error - ", err));
    }
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`Rep_Relatives_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Relatives
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`Rep_Relatives_Body`}
          active={this.state.activeIndex === 0}
        >
          <Table className={"table-custom-strip"}>
            <Table.Body>{this.state.rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default RelativesReportSection;



// WEBPACK FOOTER //
// ./src/components/reports/RelativesReportSection.js